import React from 'react';
import { useIntl } from 'react-intl';

import Button from 'carbon-react/lib/components/button';

import { AnalysisFeedbackRating } from './analysis-feedback-types';

import * as styles from './analysis-feedback-entry-point.scss';

interface AnalysisFeedbackEntryPointProps {
  hasFeedback: boolean;
  onOpen: (rating?: AnalysisFeedbackRating) => void;
  selectedRating?: AnalysisFeedbackRating | null;
}

export const AnalysisFeedbackEntryPoint = ({
  hasFeedback,
  onOpen,
  selectedRating = null
}: AnalysisFeedbackEntryPointProps) => {
  const intl = useIntl();

  if (hasFeedback) {
    return (
      <Button buttonType="tertiary" className={styles.viewFeedbackButton} onClick={() => onOpen()}>
        {intl.formatMessage({
          id: 'aiInsights.feedback.viewFeedback',
          defaultMessage: 'View feedback'
        })}
      </Button>
    );
  }

  const usefulLabel = intl.formatMessage({
    id: 'aiInsights.feedback.usefulRating',
    defaultMessage: 'Yes, this analysis was useful'
  });
  const notUsefulLabel = intl.formatMessage({
    id: 'aiInsights.feedback.notUsefulRating',
    defaultMessage: 'No, this analysis was not useful'
  });

  return (
    <div className={styles.entryPoint}>
      <span>
        {intl.formatMessage({
          id: 'aiInsights.feedback.usefulQuestion',
          defaultMessage: 'Was this analysis useful?'
        })}
      </span>
      <div
        className={styles.ratingButtons}
        role="group"
        aria-label={intl.formatMessage({
          id: 'aiInsights.feedback.usefulQuestion',
          defaultMessage: 'Was this analysis useful?'
        })}
      >
        <Button
          aria-label={usefulLabel}
          aria-pressed={selectedRating === 'up'}
          buttonType="secondary"
          className={`${styles.ratingButton} ${selectedRating === 'up' ? styles.selected : ''}`}
          iconType="like"
          onClick={() => onOpen('up')}
          size="small"
        >
          <span className={styles.visuallyHidden}>{usefulLabel}</span>
        </Button>
        <Button
          aria-label={notUsefulLabel}
          aria-pressed={selectedRating === 'down'}
          buttonType="secondary"
          className={`${styles.ratingButton} ${selectedRating === 'down' ? styles.selected : ''}`}
          iconType="like_no"
          onClick={() => onOpen('down')}
          size="small"
        >
          <span className={styles.visuallyHidden}>{notUsefulLabel}</span>
        </Button>
      </div>
    </div>
  );
};
